import type { Id, Item } from './types'

export const addOrUpdateItems = <T extends Item<Id>>(
  items: T[],
  newItems: T[],
): T[] => {
  const mergedMap = new Map(items.map((item) => [item.id, item]))
  newItems.forEach((item) => {
    mergedMap.set(item.id, item)
  })
  return Array.from(mergedMap.values())
}
